import { useTheme } from 'styled-components';
import { Icon } from '@kinesis/bungle';
import { CenteredLayout } from '@/components/centered-layout';

type IconMagnitude = 'medium' | 'small' | 'xsmall' | 'large' | 'xlarge';

const Loading = (props: Props) => {
  const { magnitude = 'large' } = props;
  const theme = useTheme() as any;
  return (
    <CenteredLayout centerY>
      <Icon
        animation='rotate'
        color={theme.color.blue6}
        magnitude={magnitude}
        type='spinner'
      />
    </CenteredLayout>
  );
};

type Props = {
  magnitude?: IconMagnitude;
};
export { Loading };
